import type { ReactNode } from 'react';
import Icon from '../icon/icon';
import * as styles from './Lightsource.styles';

type Props = {
  id: string;
  renderImage: () => ReactNode | null;
  renderContent: () => ReactNode | null;
  checked: boolean;
  onChange: () => void;
};
function Lightsource({
  id,
  renderImage,
  renderContent,
  checked,
  onChange,
}: Props) {
  return (
    <div className={styles.container({ border: checked ? 'checked' : 'base' })}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={styles.checkbox()}
        value={id}
        id={id}
      />
      <label htmlFor={id} className={styles.label()} aria-selected={checked}>
        <div className={styles.imageContainer()}>{renderImage()}</div>
        <div className={styles.customCheckbox().container()}>
          <div className={styles.customCheckbox().outerCircle()}>
            <Icon
              name="dot"
              color="black"
              size={12}
              className={styles.customCheckbox().innerDot()}
            />
          </div>
        </div>

        {renderContent()}
      </label>
    </div>
  );
}

export default Lightsource;
